import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { href: String }

  navigate(event) {
    if (event.target.closest("button, a")) return
    if (this.hrefValue) window.location = this.hrefValue
  }
}
